// import external dependencies
import 'jquery';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import 'slick-carousel/slick/slick.min';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,

  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Detect and Remove Date Picker Autofill
$('.gfield .datepicker').each(function () {
  $(this).attr('autocomplete', 'off');
});


// Animate Opacity
const opacity = document.querySelectorAll('.animate-opacity');

var observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.intersectionRatio > 0) {
      entry.target.classList.add('opacity');
    } else {
      entry.target.classList.remove('opacity');
    }
  });
});

opacity.forEach(image => {
  observer.observe(image);
});

// Animate Left
const fadeLeft = document.querySelectorAll('.animate-left');

var observerFadeL = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.intersectionRatio > 0) {
      entry.target.classList.add('fade-l');
    } else {
      entry.target.classList.remove('fade-l');
    }
  });
});

fadeLeft.forEach(fadel => {
  observerFadeL.observe(fadel);
});

// Animate Right
const fadeRight = document.querySelectorAll('.animate-right');

var observerFadeR = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.intersectionRatio > 0) {
      entry.target.classList.add('fade-r');
    } else {
      entry.target.classList.remove('fade-r');
    }
  });
});

fadeRight.forEach(fader => {
  observerFadeR.observe(fader);
});

// Animate Top
const fadeTop = document.querySelectorAll('.animate-top');

var observerFadeT = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.intersectionRatio > 0) {
      entry.target.classList.add('fade-t');
    } else {
      entry.target.classList.remove('fade-t');
    }
  });
});

fadeTop.forEach(fadet => {
  observerFadeT.observe(fadet);
});

// Animate Bottom
const fadeBottom = document.querySelectorAll('.animate-bottom');

var observerFadeB = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.intersectionRatio > 0) {
      entry.target.classList.add('fade-b');
    } else {
      entry.target.classList.remove('fade-b');
    }
  });
});

fadeBottom.forEach(fadeb => {
  observerFadeB.observe(fadeb);
});



// WEBPACK FOOTER //
// ./scripts/main.js